import React from 'react';
import { FormattedMessage } from 'react-intl';
import formStyle from 'acscp/components/common/form.module.scss';
import loginPageFormStyle from './loginPageForms.module.scss';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

interface CreateAccountFormSuccessProps {
    confirmationEmailSenderAddress: string;
}

const CreateAccountFormSuccess: React.FC<CreateAccountFormSuccessProps> = ({confirmationEmailSenderAddress}) => {
    return (
        // This is only a form to match the styling of the rest of the create account journey
        <form className={classNames(formStyle.Form, loginPageFormStyle.LoginPageForm)}>
            <div className={formStyle.Header}>
                <FormattedMessage
                    id={'components.auth.createAccountForm.success.title'}
                    defaultMessage={'THANK YOU FOR CREATING A JETPORTAL ACCOUNT'}
                />
            </div>
            <div className={loginPageFormStyle.SuccessMessage}>
                <p>
                    <FormattedMessage
                        id={'components.auth.createAccountForm.success.youWillReceiveEmail'}
                        defaultMessage={'You will shortly receive an email from {senderEmail}'}
                        values={{senderEmail: confirmationEmailSenderAddress}}
                    />
                </p>
                <p>
                    <FormattedMessage
                        id={'components.auth.createAccountForm.success.pleaseFollowLink'}
                        defaultMessage={'Please follow the link in this email to activate your account,'
                         + ' we just want to check that it\'s you.'}
                    />
                </p>
                {USE_MOBILE_APP_LOGIN_PAGE && <Link
                    to={'/login'}
                    className={classNames(formStyle.FormButton)}
                >
                    <FormattedMessage
                        id={'components.auth.createAccountForm.success.back'}
                        defaultMessage={'BACK'}
                    />
                </Link>}
            </div>
        </form>
    );
};

export {CreateAccountFormSuccess};
